(() => {
  const mobile = window.matchMedia('(max-width: 699px)');
  let frame = 0;

  const refresh = () => {
    frame = 0;
    if (!mobile.matches) return;

    document.querySelectorAll('product-sticky-add-to-cart').forEach((bar) => {
      const form = document.getElementById(bar.getAttribute('main-product-form'));
      const footer = document.querySelector('.shopify-section--footer');
      if (!form || !footer) return;

      const pastForm = form.getBoundingClientRect().bottom <= 0;
      const beforeFooter = footer.getBoundingClientRect().top >= window.innerHeight;
      bar.classList.toggle('is-visible', pastForm && beforeFooter);
    });
  };

  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(refresh);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  document.addEventListener('shopify:section:load', schedule);
  mobile.addEventListener('change', schedule);
  schedule();
})();
